import React from 'react'
import cn from 'classnames'
import styled from 'styled-components'

const Container = styled.div`
    width: 25px;
    height: 20px;
    position: relative;
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    cursor: pointer;

    &.open span {
        background: ${({ theme }) => theme.font.lightestColor};
    }

    span:nth-child(1) {
        top: 0px;
        transform-origin: left center;
    }

    &.open span:nth-child(1) {
        transform: rotate(45deg);
        top: -4px;
        left: 8px;
    }

    span:nth-child(2) {
        top: 8px;
        transform-origin: left center;
    }

    &.open span:nth-child(2) {
        width: 0%;
        opacity: 0;
    }

    span:nth-child(3) {
        top: 16px;
        transform-origin: left center;
    }

    &.open span:nth-child(3) {
        transform: rotate(-45deg);
        top: 14px;
        left: 8px;
    }
`

const Span = styled.span`
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${({ theme }) => theme.font.darkestColor};
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
`

const SmallerSpan = styled(Span)`
    width: 19px;
    left: 3px;
`

export type BurgerMenuButtonProps = {
    open: boolean
}

export const BurgerMenuButton = React.memo(function BurgerMenuButton({
    open,
}: BurgerMenuButtonProps): React.ReactElement {
    return (
        <Container className={cn({ open: open })} data-testid="burgerButtonIcon">
            <Span></Span>
            <SmallerSpan></SmallerSpan>
            <Span></Span>
        </Container>
    )
})
